// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + ({"12":"profiler","777":"recorder"}[chunkId] || chunkId) + "." + {"12":"ddb291e8","777":"1a00e2a4","845":"e511cff5"}[chunkId] + ".chunk.js";
};